<template>
	<div>
		<div v-for="(item, index) in items" :key="index" :id="item.groupId" v-if="filterItems(item.amountType)">
			<v-divider v-if="items.length"></v-divider>
			
			<div class="items-wrapper" v-if="items.length">
				<v-list two-line full-width nopadding>
				    <v-list-tile class="accountbook-tile">
			          	<v-list-tile-content v-ripple @click="functions.editEntry(item, true)">
			              	<v-list-tile-title>
			              		<div class="account-name">{{item.accountLedgerName}}&nbsp;</div>
			              	</v-list-tile-title>
			              <v-list-tile-sub-title>Balance:
			              	<span :class="[item.currentBalance < 0 ? 'redcolor' : 'greencolor']">&#8377; {{$root.numberToLocale(item.currentBalance)}}</span>
			              </v-list-tile-sub-title>
			            </v-list-tile-content>

			            <v-list-tile-action>

			            	<div>&#8377; {{$root.numberToLocale(item.groupTotal)}}</div>

			            	<v-btn icon @click="functions.removeEntry(item.groupId)"><v-icon>close</v-icon></v-btn>

			            	<!-- <v-menu>
					    	 	<v-btn slot="activator" icon nomargin style="width:24px;height:24px"><v-icon>more_horiz</v-icon></v-btn>

							    <v-list nopadding>

							        <v-list-tile @click="functions.editEntry(item, true)">
							          <v-list-tile-title>Edit</v-list-tile-title>
							        </v-list-tile>

							        <v-divider></v-divider>

							        <v-list-tile @click="functions.removeEntry(item.groupId)">
							          <v-list-tile-title>Remove</v-list-tile-title>
							        </v-list-tile>
							    </v-list>
						    </v-menu> -->

			            </v-list-tile-action>

				    </v-list-tile>

				    <v-expansion-panel 
				    	class="reference-panel" 
				    	v-if="item.references && item.references.length" v-model="item.expansionPanelModel" expand>

					    <v-expansion-panel-content>
					      <div slot="header" class="reference-header">Against Reference</div>
					      <v-card>
					        <v-card-text>

					        	<div class="card-items" v-if="item.onAccount">
					        	 	On Account
					        	 	<v-spacer></v-spacer>
					        	 	<span>&#8377; {{$root.numberToLocale(item.onAccount)}} {{item.amountType ? 'To Receive' : 'To Pay'}}</span>
					        	</div>

					        	<div v-for="(ref, refIndex) in item.references" :key="refIndex"
					        	 class="card-items">
					        	 	<!-- {{ref.prefix}}/{{ref.baseTransactionNumber}}{{ref.suffix ? '/'+ref.suffix : ''}} -->
					        	 	<span v-if="ref.baseTransactionNumber">{{ref.baseTransactionNumber}}</span>
					        	 	<span v-else>{{ref.baseRefNumber ? ref.baseRefNumber : ''}}</span>
					        	 	<v-spacer></v-spacer>
					        	 	<span>&#8377; {{$root.numberToLocale(ref.amount)}} {{ref.amountType ? 'To Receive' : 'To Pay'}}</span>
					        	</div>

					        	<!-- <div class="card-items" v-if="item.references.length && item.amount!=null && item.amount!=''">
					        	 	On Account
					        	 	<v-spacer></v-spacer>
					        	 	<span>&#8377; {{$root.numberToLocale(item.amount)}} {{item.amountType ? 'Dr' : 'Cr'}}</span>
					        	</div> -->

					        	


					        </v-card-text>
					      </v-card>
					    </v-expansion-panel-content>
					</v-expansion-panel>

					<v-expansion-panel class="reference-panel" v-model="expandOtherDetails" expand v-if="item.amountType != selectedNatureValue && (item.bankName || item.transType || item.refNumber || item.refDate)">

					    <v-expansion-panel-content>
					      <div slot="header" class="reference-header">Other Details</div>
					      <v-card>
					        <v-card-text>

								<div class="card-items">
					        	 	Bank Name
					        	 	<v-spacer></v-spacer>
					        	 	<span>{{item.bankName ? item.bankName : '-'}}</span>
					        	</div>

					        	<div class="card-items">
					        	 	Type
					        	 	<v-spacer></v-spacer>
					        	 	<span>{{item.transType ? item.transType : '-'}}</span>
					        	</div>

					        	<div class="card-items">
					        	 	Ref Number
					        	 	<v-spacer></v-spacer>
					        	 	<span>{{item.refNumber ? item.refNumber : '-'}}</span>
					        	</div>

					        	<div class="card-items">
					        	 	Ref Date
					        	 	<v-spacer></v-spacer>
					        	 	<span v-if="item.refDate">{{item.refDate | moment("DD-MMM-YYYY")}}</span>
					        	 	<span v-else>-</span>
					        	</div>

					        </v-card-text>
					      </v-card>
					    </v-expansion-panel-content>

					</v-expansion-panel>

				</v-list>
			
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		props:['items', 'functions', 'data', 'showAll', 'showDebitItems', 'showCreditItems', 'selectedNatureValue'],
		methods:{
			filterItems: function (amountType) {
				if(this.showAll){
					return true;
				}
				else if(this.showDebitItems && amountType==1){
					return true;
				}
				else if(this.showCreditItems && amountType==0){
					return true;
				}
				else{
					return false;
				}
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/transactions/forms/accountbooks/dialogs/trans_items.vue